<div class=" mapfre-fs-l-r flex jc-e ai-c">
  <button (click)="dialog.closeAll()" matSuffix mat-icon-button aria-label="Clear">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div class="pr-3 pl-3">
  <div class="title-text mapfre-mt-s gray1 mapfre-fs-s">
    <h1 class="title">{{ "PROVINCE_DOCTORS.TITLE" | translate }}</h1>
  </div>
  <hr class="divider1">
  <div class="dark mapfre-mt-s desc dark mapfre-fs-xl">
    <p>{{ "PROVINCE_DOCTORS.TITLE_TEXT" | translate }}<br>
      {{"PROVINCE_DOCTORS.TITLE_TEXT2" | translate}}</p>
  </div>

  <form [formGroup]="formGroup" class="row">
    <div class="col-12 col-md-8" *ngIf="formGroup && state.provinces">
      <mat-label class="label fd-col mapfre-fs-xxs uppercase dark-light">provincia</mat-label>

      <mat-form-field appearance="outline" class="w-100">
        <input placeholder="{{ 'BUTTONS.PROVINCE' | translate }}" type="text" matInput
          [formControl]="formGroup.get('province')" (blur)="allowOnlyProvinceSuggestedOptions()"
          [matAutocomplete]="auto">
        <button matSuffix mat-icon-button aria-label="Clear">
          <mat-icon *ngIf="!isAutocompleteOpen">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="isAutocompleteOpen">keyboard_arrow_up</mat-icon>
        </button>
        <mat-autocomplete (opened)="isAutocompleteOpen = true" (closed)="isAutocompleteOpen = false"
          [displayWith]="displayFn" autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let province of provincesFiltered || state.provinces || []" [value]="province">
            {{province?.nombreProvincia}}
          </mat-option>
        </mat-autocomplete>
        <mat-error
          *ngIf="formGroup.get('province')?.errors?.provinceInvalid && !formGroup.get('province')?.errors?.required">
          {{ "PROVINCE_DOCTORS.INVALID_PROVINCE" | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('province')?.errors?.required">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>
  </form>
  <div class="divider2"></div>

  <div class="flex jc-sb buttons mapfre-hide-mobile mapfre-hide-tablet w-100 mapfre-mt-s">
    <app-button (click)="dialog.closeAll()" [mr]="10" fw=500 fs="16" width="45" size="large" type="outline"
      [text]="'BUTTONS.CANCEL' | translate">
    </app-button>
    <app-button (click)="downloadPdf()" [disabled]="!formGroup.valid" [ml]="10" fw=500 fs="16" width="45" size="large"
      type="primary" [text]="'BUTTONS.DOWNLOAD_PDF' | translate"></app-button>
  </div>
  <div class="fd-col mapfre-hide-desktop flex w-100 mapfre-mt-sm buttons">
    <app-button (click)="dialog.closeAll()" type="outline" fw=500 fs="16" [mr]="0" [text]="'Cancelar'"></app-button>
    <app-button (click)="downloadPdf()" [disabled]="!formGroup.valid" type="primary" fw=500 fs="16" [mt]="10"
      [text]="'BUTTONS.DOWNLOAD_PDF' | translate"></app-button>
  </div>
</div>